(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-overlay"]) return;
  try {
    
  if (!customElements.get('bff-holiday-notice')) {
    customElements.define('bff-holiday-notice', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.bff-holiday-dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.querySelectorAll('[data-holiday-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });

        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bff-holiday-is-open');
        }, options);

        // Re-open when selected, and get out of the way when editing other sections.
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
              this.openNotice();
            } else if (this.dialog.open) {
              this.dialog.close();
            }
          }, options);
        }

        this.openNotice();
      }

      openNotice() {
        if (!this.isConnected || !this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('bff-holiday-is-open');
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.dialog && this.dialog.open) this.dialog.close();
        document.documentElement.classList.remove('bff-holiday-is-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
